import { render, staticRenderFns } from "./SupplierInspectionDecisionModal.vue?vue&type=template&id=65aa4cde"
import script from "./SupplierInspectionDecisionModal.vue?vue&type=script&lang=js"
export * from "./SupplierInspectionDecisionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports